import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { aprovacaoService } from "@/services/api/aprovacao.service";
import { useAprovacaoNotificationsContext } from "@/lib/approval-notifications-context";

/** Atualização a cada 5 minutos (badge de notificações de aprovação). */
const REFRESH_INTERVAL_MS = 5 * 60 * 1000;

export const APROVACAO_NOTIFICACOES_QUERY_KEY = ["aprovacao", "notificacoes"] as const;

export function useAprovacaoNotifications({ enabled = true }: { enabled?: boolean } = {}) {
  const { setRefreshFunction } = useAprovacaoNotificationsContext();

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: APROVACAO_NOTIFICACOES_QUERY_KEY,
    queryFn: () => aprovacaoService.getNotificacoes(),
    enabled,
    refetchInterval: REFRESH_INTERVAL_MS,
    staleTime: REFRESH_INTERVAL_MS,
    refetchOnWindowFocus: false,
    // Badge decorativo: falha não pode travar nem estourar erro na UI (ver useAprovacoesResumo).
    throwOnError: false,
    retry: 1,
  });

  // Mantém o contrato do contexto: mutações (aprovar/reprovar) chamam
  // refreshNotifications → revalida o badge.
  useEffect(() => {
    setRefreshFunction(() => {
      void refetch();
    });
  }, [setRefreshFunction, refetch]);

  return {
    notificationCount: data ?? 0,
    isLoading,
    error: error ? "Failed to fetch notifications" : null,
    refreshNotifications: () => {
      void refetch();
    },
  };
}
